// eslint-disable-next-line import/prefer-default-export
export var LOGO_COVER_TRANSLATIONS = {
    logoCover: {
        titleLogo: 'Logotipo da filial',
        titleCover: 'Imagem de capa',
        titleExample: 'Esta é a aparência do seu logotipo e capa:',
        fileUpload: {
            buttonText: 'Selecione um arquivo',
            title: 'Arraste as imagens aqui',
            formats: 'Formatos:',
            maxSize: 'Tamanho máximo',
            remove: 'Eliminar arquivo',
        },
        editor: {
            cropText: 'Gravar',
            rotateLeftText: 'Girar à la izquierda',
            editImageText: 'Editar',
            onSaveText: 'Ok',
            rotateRightText: 'Girar à direita',
            zoomInText: 'Acercar',
            zoomOutText: 'Alejar',
        },
        errors: {
            errorLoad: 'Hubo um erro ao carregar',
            invalidType: 'O formato do arquivo não é permitido',
            tooLarge: 'O tamanho do arquivo é mais permitido',
            tooSmall: 'A resolução da imagem é menor do que o permitido',
            tooManyFiles: 'O número de arquivos permitidos foi excedido',
            genericError: 'Tentar novamente',
        },
        modal: {
            ok: 'Entendido',
        },
    },
};
